import React, { Component } from "react";
import { Link } from "react-router-dom";

import SignHeader from "../component/SignHeader";

import "../scss/style.scss";
import "../scss/sign.scss";

class Home extends Component {
	render() {
		return (
			<React.Fragment>
				<SignHeader />
				<div className="signMapLayout">
					<div className="libraryInfo">
						<h4 className="libraryName">한국도서관</h4>
						<p className="libraryAddress">03965 서울특별시 마포구 성산로 128 마포중앙도서관</p>
					</div>
					<div className="libraryConfirm">
						<label>이 도서관이 맞나요?</label>
						<div className="libraryConfirm-btn">
							<button className="btn btn-yes">예</button>
							<button className="btn btn-no">아니오</button>
						</div>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

export default Home;
